import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import * as PodcastActions from '../../actions';
import BackstagePodcastProgramSubheaderLarge from '../common/BackstagePodcastSubheader/BackstagePodcastProgramSubheaderLarge';
import BackstagePodcastProgramSubheaderSmall from '../common/BackstagePodcastSubheader/BackstagePodcastProgramSubheaderSmall';

import BackstagePodcastPageBase from './BackstagePodcastPageBase';

const BackstagePodcastProgramPageBase = props => {
  const { programId } = props;

  useEffect(() => {
    props.setActiveBackstageProgramId({ programId });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BackstagePodcastPageBase
      pandoraId={programId}
      subheaderLarge={<BackstagePodcastProgramSubheaderLarge programId={programId} />}
      subheaderSmall={<BackstagePodcastProgramSubheaderSmall programId={programId} />}
      mainContent={props.mainContent}
    />
  );
};

BackstagePodcastProgramPageBase.propTypes = {
  setActiveBackstageProgramId: PropTypes.func.isRequired,
  mainContent: PropTypes.node.isRequired,
  programId: PropTypes.string.isRequired,
};

const mapDispatchToProps = {
  setActiveBackstageProgramId: PodcastActions.setActiveBackstageProgramId,
};

export default connect(null, mapDispatchToProps)(BackstagePodcastProgramPageBase);
